import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IVehicleImage } from 'src/app/core/models/vehicle-image.model';
import { TranslateService } from '@ngx-translate/core';
import { VehicleService } from 'src/app/core/services/vehicle.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.css']
})
export class ImageUploadComponent implements OnInit {

  mainImage;
  mainUpload = null;
  @Input() image: IVehicleImage;
  @Input() vehicleId: string;

  @Output() close = new EventEmitter();
  @Output() refresh = new EventEmitter();

  imageType = '0';

  imageForUpload;
  editImageId;
  mainEditPath;
  editImagePosition;

  originalEdit: any;
  originalEditPath: any;

  isUploading = false;

  newImage = {
    name: 'new background',
    position: '0',
    helpMask: null,
    targetKey: null,
    type: ''
  };

  userType: string;

  constructor(
    private translate: TranslateService,
    private vehicleService: VehicleService,
    private toastr: ToastrService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {

    this.authService.LoggedinUser
      .subscribe(user => {
        if (user) {
          this.userType = user.role.name;
        }
      });

    this.mainImage = undefined;
    this.mainEditPath = undefined;
    this.originalEdit = undefined;
    this.originalEditPath = undefined;
    this.mainUpload = null;
    this.editImageId = '';

    this.editImageId = this.image.id;
    this.editImagePosition = this.image.position;

    if (this.image.id !== '') {
      this.newImage.type = this.image.type;
    } else {
      this.newImage.type = '0';
    }

    if (this.image.mainFile && this.image.mainFile.path) {
      this.mainImage = this.image.mainFile;
      this.mainEditPath = this.image.mainFile.path;
    }

    if (this.image.originalFile && this.image.originalFile.path) {
      this.originalEdit = this.image.originalFile;
      this.originalEditPath = this.image.originalFile.path;
    }

  }

  addImageFile(image, type) {
    const formData: FormData = new FormData();
    formData.append('image', image);

    if (image == undefined) {
      return this.translate.get('vehicles.vehicle.selectImageFirst').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    this.vehicleService.addImageFile(formData, this.editImageId, type).subscribe(res => {
      this.toastr.success('File successfully added.');
      this.refresh.emit();
      this.close.emit();
    }, err => {
      
      this.close.emit();
    });
  }

  patchImageFile(image, type) {

    if (this.isUploading) return;
    this.isUploading = true;

    if (!image) {
      this.isUploading = false;
      return this.translate.get('vehicles.vehicle.selectImageFirst')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
    }

    const formData: FormData = new FormData();
    formData.append('image', image);

    let fileId;
    if (type === 'main') {
      fileId = this.mainImage?.id;
    } else {
      fileId = this.originalEdit?.id;
    }

    this.vehicleService.patchImageFile(formData, this.editImageId, fileId)
      .pipe(
        finalize(() => this.isUploading = false)
      )
      .subscribe({
        next: () => {
          this.toastr.success('File successfully changed.');
          this.refresh.emit();
          this.close.emit();
        },
        error: () => {
          this.close.emit();
        }
      });
  }

  getFile(event, type: string, state: string) {
    this.imageForUpload = null;

    if (event.target.files && event.target.files[0]) {

      // console.log(event.target.files);

      this.imageForUpload = event.target.files[0];

      const checkimg = this.imageForUpload.name.toLowerCase();
      if (!checkimg.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG)$/)) {
        this.translate.get('errors.errorImageExtensions').subscribe((text: string) => {
          this.toastr.error(text);
        });
        return false;
      }

      if (this.editImageId !== '') {
        this.showFile(this.imageForUpload, 'main');
        // state === 'add' ?
        // this.addImageFile(this.imageForUpload, type) : this.patchImageFile(this.imageForUpload, type)
      } else {
        this.newImage.position = this.editImagePosition;
        const imageType = this.getImageType(this.imageForUpload);
        imageType != undefined ? this.newImage.type = imageType : this.newImage.type = 'exterior';
        this.newImage.name = this.imageForUpload.name;
        this.showFile(this.imageForUpload, 'main');
      }

    }
  }

  fileSelect(content) {
    // event.preventDefault();
    const element: HTMLElement = document.getElementById(`file-${content}`) as HTMLElement;
    element.click();

  }

  createImageAndFile() {
    if (this.imageForUpload != null) {
      // name i type
      this.vehicleService.addNewImage(this.vehicleId, this.newImage).subscribe(res => {
        const imageId = res.id;
        this.toastr.success('Success.');

        const formData: FormData = new FormData();
        formData.append('image', this.imageForUpload);

        this.vehicleService.addImageFile(formData, imageId, 'main').subscribe(res => {
          this.toastr.success('File successfully added.');

          // ! REFRESUJ VOZILA U DRUGOJ KOMPONENTI
          // this.ngOnInit();
          this.mainUpload = null;
        }, err => {
          
          this.toastr.error(err.message);
          this.mainUpload = null;
        });
      }, err => {
        this.toastr.error(err.message);
      });
    } else {
      this.translate.get('vehicles.vehicle.selectImageFirst').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    this.close.emit();
  }

  showFile(image, type) {

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      if (type === 'main') {
        this.mainUpload = reader.result;
        this.mainEditPath = reader.result;
      }
      // type === 'main' ? this.mainUpload = reader.result : this.originalUpload = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getImageType(image) {
    const x = image.name.split('__');
    console.log(x);
    let type;

    if (x[4] !== undefined) {
      switch (x[4]) {
        case 'ext':
          type = 'exterior';
          break;
        case 'int':
          type = 'interior';
          break;
        case 'det':
          type = 'details';
          break;
        case 'non':
          type = 'details';
          break;
        default:
          break;
      }
    }

    return type;
  }

  uploadMainImage(image) {

    if (this.isUploading) return;
    this.isUploading = true;

    if (image === undefined) {
      this.isUploading = false;
      return this.translate.get('errors.pleaseUploadImage')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
    }

    const formData = new FormData();
    formData.append('image', image);

    this.vehicleService.uploadMainImage(this.editImageId, formData)
      .pipe(
        finalize(() => this.isUploading = false)
      )
      .subscribe({
        next: res => {
          this.mainImage
            ? this.toastr.success('File successfully changed.')
            : this.toastr.success('File successfully added.');

          this.refresh.emit();
          this.close.emit();
        },
        error: err => {
          this.toastr.error(err?.message || 'Error');
        }
      });
  }

}
